<template>
  <div class="col-12">
    <div class="row">
      <vue-headful :title="`Dashboard • ${$store.state.settings.settings.site_name}`" />
      <div class="col-md-12">
        <h1>Dashboard</h1>
      </div>
      <div
        class="col-xl-3 col-lg-4 col-md-6"
        v-for="card in stats"
        :key="card.subtitle">
        <stats-card
          :title="card.title"
          :subtitle="card.subtitle"
          :type="card.type"
          :icon="card.icon"
          :link="card.link">
          <div
            v-if="card.footer"
            slot="footer"
            v-html="card.footer" />
        </stats-card>
      </div>
      <!-- <div class ="col-lg-12">
        <card class="card">
          <div>
            <h2 class="card-title">Sample section</h2>
          </div>
        </card>
      </div> -->
    </div>
  </div>
</template>

<script>
import StatsCard from 'src/components/UI/Cards/StatsCard';

export default {
  name: 'Dashboard',
  components: {
    StatsCard,
  },
  props: {
    stats: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style module>
.subtitle {
  color: gray;
}
</style>
